@use "variables" as *;

.cancelButton {
  color: indianred;
}

.textField {
  height: 60px;
  margin-bottom: $spacing-s;
}

.loadingDiv {
  width: 50px;
  padding-left: $spacing-m;
}

.subtitle {
  font-size: $fontSize-m;
  font-weight: bold;
  text-align: center;
}

.description {
  font-size: $fontSize-s;
  font-weight: normal;
  text-align: center;
}

.saveButton {
  margin-bottom: 28px;
}
